<template>
  <v-container
    class="pa-0 max-width-sm"
  >
    <v-card
      flat
      tile
      class="pt-2"
    >
      <v-toolbar
        flat
      >
        <v-toolbar-title>
          {{ $t('Attendance.OTTitle') }}: {{ YYYYMM }}
        </v-toolbar-title>
      </v-toolbar>

      <div class="pa-4">
        <template v-if="otProposals.length">
          <v-row no-gutters>
            <v-col
              cols="1"
              align-self="center"
            />
            <v-col
              cols="2"
              align-self="left"
            >
              {{ $t('Attendance.Entity') }}
            </v-col>
            <v-col
              cols="4"
            >
              {{ $t('Attendance.ProposalNo') }}
            </v-col>
            <v-col
              cols="3"
            >
              {{ $t('Attendance.RelatedRecordCount') }}
            </v-col>
          </v-row>
          <br>
          <v-row
            v-for="proposal in greaterThanZeroOtProposals"
            :key="proposal.formCode"
            dense
          >
            <v-col
              cols="1"
              align-self="center"
            >
              <v-icon v-if="proposal.isDafVerify === true">
                {{ mdiCheckboxMarkedCircle }}
              </v-icon>
              <v-icon v-else>
                <!--mdi-checkbox-blank-circle-->
              </v-icon>
            </v-col>

            <v-col
              cols="2"
              align-self="center"
            >
              {{ proposal.abbr }}
            </v-col>

            <v-col
              cols="4"
            >
              {{ proposal.proposalNo }}
            </v-col>

            <v-col
              cols="3"
            >
              {{ proposal.staffDraftOTRecNum }}
            </v-col>
          </v-row>

          <v-divider class="my-4" />
        </template>

        <h3 class="text-subtitle-1">
          {{ $t('Attendance.OT.status') }}
        </h3>
        <v-row no-gutters>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <span class="text-h6 mr-1">{{ $t('Attendance.OT.Annual') }}</span><span class="text-h5 primary--text mr-1">{{ nvl(otInfoYear, 0) }}</span><span class="grey--text mr-4">{{ $t('Attendance.Hours') }}</span>
            <span class="text-h6 mr-1">{{ $t('Attendance.OT.Month') }}</span><span class="text-h5 primary--text mr-1">{{ nvl(otInfoMonth, 0) }}</span><span class="grey--text">{{ $t('Attendance.Hours') }}</span>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="8"
            class="text-body-2 grey--text"
          >
            <div>{{ $t('Attendance.HasDone') }} - {{ $t('Attendance.OT.Annual') }} {{ nvl(confirmedInfoYear, 0) }}  {{ $t('Attendance.Hours') }}  <span class="grey--text mx-3">|</span>  {{ $t('Attendance.OT.Month') }} {{ nvl(confirmedInfoMonth, 0) }}  {{ $t('Attendance.Hours') }}</div>
            <div>{{ $t('Attendance.HasReservedButNotDone') }} - {{ $t('Attendance.OT.Annual') }} {{ nvl(availableYear, 0) }}  {{ $t('Attendance.Hours') }}  <span class="mx-3">|</span>  {{ $t('Attendance.OT.Month') }} {{ nvl(availableMonth, 0) }}  {{ $t('Attendance.Hours') }}</div>
          </v-col>
        </v-row>
        <br>

        <template v-if="otProposals.length">
          <h3 class="text-subtitle-1">
            {{ $t('Attendance.OT.ProposalOfCurrentMonth') }}
          </h3>
          <v-row
            v-for="proposal in otProposals"
            :key="proposal.formCode"
            dense
          >
            <v-col>
              {{ proposal.proposalNo }} - {{ $t('Attendance.DayHours') }}: <span class="text-h6 primary--text">{{ nvl(proposal.confirmedStaffDayHours,0) }}</span>, {{ $t('Attendance.NightHours') }}: <span class="text-h6 primary--text">{{ nvl(proposal.confirmedStaffNightHours,0) }}</span>
              <br class="d-md-none"> ({{ $t('Attendance.Period') }}: <span class="primary--text">{{ dateStrToddmm(proposal.confirmedStartDate) }} - {{ dateStrToddmm(proposal.confirmedEndDate) }}</span>)
            </v-col>
          </v-row>

          <br>
        </template>

        <div class="d-block d-md-flex">
          <div>
            <v-btn
              color="primary"
              :href="hrOtEditUrl"
              class="mr-2 mt-2"
            >
              {{ $t('Attendance.Action.FillOT') }}
            </v-btn>

            <v-btn
              outlined
              color="primary"
              :href="hrOtProposalUrl"
              class="mt-2"
            >
              <v-icon left>
                {{ mdiPlus }}
              </v-icon>
              {{ $t('Workflow.Form.OTProposal') }}
            </v-btn>
          </div>

          <v-spacer />

          <div class="mt-2 d-flex">
            <v-btn
              depressed
              class="mr-3"
              @click="setDateToToday"
            >
              {{ $t('Attendance.ThisMonth') }}
            </v-btn>

            <v-spacer class="d-md-none" />

            <v-btn
              depressed
              class="mr-3"
              @click="previousMonth"
            >
              <v-icon>{{ mdiChevronLeft }}</v-icon>
            </v-btn>

            <v-btn
              depressed
              @click="nextMonth"
            >
              <v-icon>{{ mdiChevronRight }}</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>

import siteIntegrate from '@/api/general/siteIntegrate'
import systemApi from '@/api/general/system'
import otApi from '@/api/ot/ot'
import datetimeUtil from '@/utils/datetimeUtil'
import stringUtil from '@/utils/stringUtil'
import { mdiCheckboxMarkedCircle, mdiPlus, mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default {
  components: {
  },
  data: function () {
    return {
      refDate: null,
      otProposals: [],
      otInfoYear: 0,
      otInfoMonth: 0,
      confirmedInfoYear: 0,
      confirmedInfoMonth: 0,
      mdiCheckboxMarkedCircle: mdiCheckboxMarkedCircle,
      mdiPlus: mdiPlus,
      mdiChevronLeft: mdiChevronLeft,
      mdiChevronRight: mdiChevronRight
      // hrOtDownloadUrl: siteIntegrate.hrOtDownloadUrl()
    }
  },
  computed: {
    greaterThanZeroOtProposals: function () {
      // return this.otProposals
      return this.otProposals.filter(function (item) {
        return item.staffDraftOTRecNum > 0
      })
    },
    hrOtEditUrl: function () {
      return siteIntegrate.hrOtEditUrl()
    },
    hrOtProposalUrl: function () {
      return siteIntegrate.hrOtProposalUrl()
    },
    availableYear: function () {
      if (this.otInfoYear && this.confirmedInfoYear) {
        return this.otInfoYear - this.confirmedInfoYear
      } else {
        return 0
      }
    },
    availableMonth: function () {
      if (this.otInfoMonth && this.confirmedInfoMonth) {
        return this.otInfoMonth - this.confirmedInfoMonth
      } else {
        return 0
      }
    },
    YYYYMM: function () {
      if (this.refDate) {
        return datetimeUtil.getYear(this.refDate) + '-' + datetimeUtil.getMonth(this.refDate)
      } else {
        return ''
      }
    },
    year: function () {
      if (this.refDate) {
        return datetimeUtil.getYear(this.refDate)
      } else {
        return ''
      }
    },
    month: function () {
      if (this.refDate) {
        return datetimeUtil.getMonth(this.refDate)
      } else {
        return ''
      }
    }
  },
  watch: {
    refDate: function (newDate, oldDate) {
      if (newDate && newDate !== oldDate) {
        otApi.getStaffOTProposalInfo(this.month, this.year, resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.otProposals = resp.data
          }
        })
        otApi.getStaffOTInfo(this.month, this.year, resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.otInfoYear = resp.data.yearlyOTHours
            this.otInfoMonth = resp.data.monthlyOTHours
          }
        })
        otApi.getStaffOTDafConfirmedInfo(null, this.year, resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.confirmedInfoYear = resp.data.dayHours + resp.data.nightHours
          }
        })
        otApi.getStaffOTDafConfirmedInfo(this.month, this.year, resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.confirmedInfoMonth = resp.data.dayHours + resp.data.nightHours
          }
        })
      }
    }
  },
  created () {
    // this.refDate = '2019-01'
    this.setDateToToday()
  },
  methods: {
    nvl: function (str, rpl) {
      return stringUtil.nvl(str, rpl)
    },
    dateStrToddmm: function (dateStr) {
      if (dateStr) {
        return datetimeUtil.dateStrToddmm(dateStr)
      } else {
        return ''
      }
    },
    setDateToToday: function () {
      systemApi.getServerDateTime(rsp => {
        this.refDate = datetimeUtil.setDay(datetimeUtil.cutTime(rsp), 1)
      })
    },
    nextMonth: function () {
      this.refDate = datetimeUtil.nextMonth(this.refDate)
    },
    previousMonth: function () {
      this.refDate = datetimeUtil.previousMonth(this.refDate)
    }
  }
}
</script>
